import type { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import { InnerBlocks } from "@wordpress/block-editor";

export default function TeaserSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return (
    <div>
      <img src={attributes.imageUrl} alt={attributes.imageAlt} />
      <h3>{attributes.heading}</h3>
      <div
        className="content"
        dangerouslySetInnerHTML={{ __html: attributes.content || "" }}
      ></div>
      <a href={attributes.linkUrl}>{attributes.button_text}</a>
    </div>
  );
}
